<template>
  <b-modal no-close-on-backdrop ref="modal" :title="'Emitir NF'" header-class="border-bottom-0" size="lg">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" v-if="this.$store.state.company_config.ambiente_nfe == 2">
          <div class="alert alert-info" role="alert">Você esta no ambiente de Homologação da NF-e</div>
        </div>
      </div>
      <br />
      <template v-if="step == 1">
        <div class="row">
          <div class="col-md-3">
            <number-input :alias="'Modelo'" :value="resquestResponse.model" :decimalPlaces="0" :disabled="true" />
          </div>
          <div class="col-md-3">
            <number-input :alias="'Série'" :value="resquestResponse.serie" :decimalPlaces="0" :disabled="true" />
          </div>
          <div class="col-md-6">
            <number-input :alias="'Número'" v-model="form.number_nf.value" :decimalPlaces="0" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea maxlength="500" class="form-control" id="exampleFormControlTextarea1" rows="5"
              placeholder="Informacoes complementares" v-model="form.informacao_complementar.value" />
          </div>

        </div>
      </template>

      <template v-if="step == 2">
        <div class="row">
          <div class="col-9">
            <select-input v-model="form.mod_frete.value" :options="form.mod_frete.options"
              alias="Quem será o resposavel pelo frete?" />
          </div>
        </div>
        <br />
        <br />
        <template v-if="form.mod_frete.value != 9">
          <div class="row">
            <div class="col-6">
              <shipping-company-search v-model="form.transportadora_id.value" />
            </div>
            <div class="col-3">
              <text-input alias="Telefone" />
            </div>
            <div class="col-3">
              <text-input alias="email" />
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <text-input alias="RNTC do Veiculo" v-model="form.RNTC.value" />
            </div>
            <div class="col-4">
              <text-input alias="Placa do Veiculo" v-model="form.vehicle_plate.value" />
            </div>
            <div class="col-4">
              <select-input alias="UF" v-model="form.vehicle_uf.value" :options="form.vehicle_uf.options" />
            </div>
          </div>
        </template>

        <div class="row" v-if="form.mod_frete.value != 9">
          <div class="col-4">
            <text-input alias="Nº de indentificação dos volumes" v-model="form.indentidica_volume.value" />
          </div>
          <div class="col-4">
            <text-input alias="Quantidade de Volumes" v-model="form.quantity_volume.value" />
          </div>
          <div class="col-4">
            <text-input alias="Tipo de Volume" v-model="form.type_volume.value" />
          </div>
          <div class="col-4">
            <number-input alias="Peso Bruto Total" v-model="form.peso_bruto.value" />
          </div>
          <div class="col-4">
            <number-input alias="Peso Liquido Total" v-model="form.peso_liquido.value" />
          </div>
        </div>
      </template>
      <template v-if="step == 3">
        <div class="row justify-content-between">
          <div class="col-5">Valor da Nota Fiscal:</div>
          <div class="col-2 text-right">
            <b>{{ form.value_nf.value | decimal }}</b>
          </div>
        </div>
        <!-- <div class="row justify-content-between">
                <div class="col-md-5">Valor Pago:</div>
                <div class="col-md-2 text-right">
                    <number-input :form="form" :name="'received_value'" v-model="form.received_value.value" />
                </div>
            </div>
            <div class="row justify-content-between">
                <div class="col-5">Troco:</div>
                <div class="col-2 text-right">
                    <b>{{ (form.troco.value = form.received_value.value - form.value_nf.value) | decimal}}</b>
                </div>
        </div>-->
      </template>

      <error-handler :error="error" />

      <div class="row">
        <div class="col-12">
          <b-alert v-model="hasValidationError" variant="danger" dismissible>
            <template v-if="hasEmpresaErrors">
              <b>Erros no cadastro da empresa:</b>
              <br />
              <div v-for="(errors, index) in validationError['Empresa']" :key="index">
                <template v-for="erro in errors">{{ erro }}</template>
              </div>
              <br />
            </template>
            <template v-if="hasClienteErrors">
              <b>Erros no cadastro do cliente:</b>
              <br />
              <div v-for="(errors, index) in validationError.Cliente" :key="index">
                <template v-for="erro in errors">{{ erro }}</template>
              </div>
              <br />
            </template>

            <template v-if="productErrors">
              <b>Erros nos produtos:</b>
              <br />
              <br />
              <template v-for="(productError, index) in productErrors">
                <div class="mb-3" :key="index">
                  <!-- <template v-for="erro in errors">
                    {{ erro }}
                  </template>-->
                  <b>{{ index }}</b>
                  <div v-for="(errors, index) in productError" :key="index">
                    <template v-for="erro in errors">{{ erro }}</template>
                  </div>
                </div>
              </template>
            </template>
          </b-alert>
        </div>
      </div>
    </div>

    <!-- slot footer -->
    <div slot="modal-footer">
      <button role="button" class="btn btn-secondary ml-3" v-if="step > 1" @click="step = step - 1">
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
      <button role="button" class="btn btn-success ml-3" v-if="step == 1" @click="stepTwo">
        <i class="fas fa-arrow-right"></i> Próximo
      </button>
      <button role="button" class="btn btn-success ml-3" v-if="step == 2" @click="stepTree">
        <i class="fas fa-arrow-right"></i> Próximo
      </button>

      <!-- <button role="button" class="btn btn-outline-secondary" v-if="step == 4" @click="$refs.modal.hide()">
            <i class="fas fa-times"></i> Cancelar
      </button>-->
      <button role="button" class="btn btn-success" style="margin-left:5px" @click="storenfe"
        v-if="!isNfe && step == 3">
        <i class="fas fa-check"></i> Emitir NFc-e
      </button>
      <button role="button" class="btn btn-success" style="margin-left:5px" @click="storenfe" v-if="isNfe && step == 3">
        <i class="fas fa-check"></i> Emitir NF-e
      </button>
    </div>

  </b-modal>
</template>

<script>
import Form from "./../../../mixins/Form";
import ShippingCompanySearch from "./../../ShippingCompanySearch";

export default {
  components: {
    ShippingCompanySearch
  },

  data: function () {
    return {
      form: new Form({
        mod_frete: {
          value: 9,
          options: {
            0: "Contratação do Frete por conta do Remetente(CIF)",
            1: "Contratação do Frete por conta do Destinatário(FOB)",
            2: "Contratação do Frete por conta de Terceiros",
            3: "Transporte Próprio por conta do Remetente",
            4: "Transporte Próprio por conta do Destinatário",
            9: "Sem Ocorrência de Transporte"
          }
        },
        informacao_complementar: {

        },
        shipping_value: {},

        type_shipping: {},

        add_shipping_value: {},

        transportadora_id: {},

        vehicle_plate: {},

        vehicle_uf: {
          options: {
            AC: "Acre",
            AL: "Alagoas",
            AM: "Amazonas",
            AP: "Amapá",
            BA: "Bahia",
            CE: "Ceará",
            DF: "Distrito Federal",
            ES: "Espírito Santo",
            GO: "Goiás",
            MA: "Maranhão",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Pará",
            PB: "Paraíba",
            PR: "Paraná",
            PE: "Pernambuco",
            PI: "Piauí",
            RJ: "Rio de Janeiro",
            RN: "Rio Grande do Norte",
            RS: "Rio Grande do Sul",
            RO: "Rondônia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "São Paulo",
            SE: "Sergipe",
            TO: "Tocantins"
          }
        },

        RNTC: {},

        indentidica_volume: {},

        quantity_volume: {},

        type_volume: {},

        peso_bruto: {},

        peso_liquido: {},

        troco: {
          value: 0
        },

        received_value: {
          alias: "Valor a Receber",
          default: 0,
          validate: {
            required: true
          }
        },

        order_id: {},

        value_nf: {},

        model: {},

        number_nf: {
          value: 0
        }
      }),

      step: 1,

      loading: false,

      resquestResponse: {},

      error: null,

      validationError: null
    };
  },

  computed: {
    isNfe() {
      return this.model == "55";
    },
    urls() {
      if (this.model == "55") {
        return {
          store: "api/order/emitordernfe",
          print: "nfe/danfe/"
        };
      } else {
        return {
          store: "api/order/emitordernfe",
          print: "nfe/danfe/"
        };
      }
    },

    hasValidationError() {
      return this.validationError != null;
    },

    hasEmpresaErrors() {
      if (this.validationError == null) {
        return false;
      }

      if (typeof this.validationError.Empresa == "undefined") {
        return false;
      }

      return true;
    },

    hasClienteErrors() {
      if (this.validationError == null) {
        return false;
      }

      if (typeof this.validationError.Cliente == "undefined") {
        return false;
      }

      return true;
    },

    productErrors() {
      if (this.validationError == null) {
        return null;
      }

      const notAllowed = ["Empresa", "Cliente"];

      return Object.keys(this.validationError)
        .filter(key => !notAllowed.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.validationError[key];
          return obj;
        }, {});
    }
  },

  methods: {
    open(orderId, valueNf, model) {
      this.resetForm();
      this.form.order_id.value = orderId;
      this.form.value_nf.value = valueNf;
      this.form.model.value = model;
      this.form.mod_frete.value = 9;
      this.requestSerieAndNumberNfe();
    },

    requestSerieAndNumberNfe() {
      axios
        .post("api/nfe/selectserieandnumbernfe/" + this.form.model.value)
        .then(response => {
          this.resquestResponse = response.data.series;
          this.form.number_nf.value = response.data.numberNf;

          this.$refs.modal.show();
        })
        .catch(error => {
          console.log(error);
        });
    },

    storenfe() {
      this.$store.commit("showLoading");
      axios
        .post(this.urls.store, this.form.getValues())
        .then(response => {
          //console.log(response.data)
          let id = response.data.chNfe;

          window.open(this.urls.print + id, "_newtab");

          this.$refs.modal.hide();
          this.$emit("stored");
          this.$store.commit("hideLoading");
        })
        .catch(error => {
          this.processError(error);
          this.$store.commit("hideLoading");
        });
    },

    processError(error) {
      if (!this.is422(error)) {
        this.error = error;
      } else {
        this.processValidationError(error);
      }
    },

    is422(error) {
      try {
        return error.response.status == 422;
      } catch {
        return false;
      }
    },

    processValidationError(error) {
      console.log(error.response.data.errors);
      this.validationError = error.response.data.errors;
    },

    resetForm() {
      this.validationError = null;

      this.step = 1;

      this.form.reset();
    },

    stepTwo() {
      this.step = 2;
    },

    stepTree() {
      this.step = 3;
    },

    stepFour() {
      this.step = 4;
    }
  }
};
</script>

<style></style>
